import { stateAcronym } from 'types';

export const shortenState = (text: string) => {
  let newText = '';
  const stateKeys = Object.keys(stateAcronym);

  for (const stateKey of stateKeys) {
    if (text.includes(stateKey)) {
      const reg = new RegExp(`,\\s${stateKey},?`);
      newText = text.replace(reg, ` ${stateAcronym[stateKey]}`);
      break;
    }
  }

  return newText || text;
};

export const arcGISWorldGeocodingLabelTrim = (
  label: string,
  keepCountryCode?: boolean
) => {
  return label.split(',').length > 0 && !keepCountryCode
    ? shortenState(label.substring(0, label.length - 5).trim())
    : shortenState(label);
};
